export default "__VITE_ASSET__DUu4KirN__"